import { forwardRef, useId } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'

type Size = 'sm' | 'md' | 'lg'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'onChange' | 'type'> {
  checked?: boolean
  onChange?: (next: boolean) => void
  label?: ReactNode
  size?: Size
  loading?: boolean
  wrapperClassName?: string
}

export const Radio = forwardRef<HTMLInputElement, Props>(function Radio(
  { checked, onChange, label, size = 'md', loading = false, disabled, className, wrapperClassName, id, name, value, ...rest },
  ref,
) {
  const autoId = useId()
  const inputId = id ?? autoId
  const classes = [
    'dsRd',
    size !== 'md' ? `dsRd--${size}` : '',
    disabled || loading ? 'is-disabled' : '',
    loading ? 'is-busy' : '',
    wrapperClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={classes} htmlFor={inputId}>
      <input
        ref={ref}
        id={inputId}
        type="radio"
        name={name}
        value={value}
        className={`dsRd__input ${className ?? ''}`.trim()}
        checked={checked}
        onChange={(event) => onChange?.(event.target.checked)}
        disabled={disabled || loading}
        {...rest}
      />
      <span className="dsRd__ring" aria-hidden="true" />
      {label && <span className="dsRd__label">{label}</span>}
    </label>
  )
})
